import { render, staticRenderFns } from "./ShopIFrame.vue?vue&type=template&id=15103c72&"
import script from "./ShopIFrame.vue?vue&type=script&lang=js&"
export * from "./ShopIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports